<template>
  <app-layout :subtitle="$t('headingSubtitle')">
    <div class="l-home">
      <button class="l-home__button" @click="redirectToAuthenticated('/uploadreceive')">{{ $t('home.button') }}</button>

      <div class="l-home__statistics-container">
        <div class="l-home__chart-container">
          <bar-chart
            :options="options"
            :chart-data="datacollection"
            />
        </div>
        <div class="l-home__months-text">{{ $t('home.totalDataByMonth') }}</div>
        <div class="l-home__files-text">{{ $t('home.totalFilesDownloaded') }}: {{ statistics.stPrenesenih }} </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from './layout/AppLayout'
import BarChart from './chartjs/BarChart'

export default {
  name: "Home",
  components: {
    AppLayout,
    BarChart
  },
  data() {
    return {
      redirectUrl: '/',
      hkom: window.appState.hkom,
      statistics: window.appState.statistics,
      graphJson: window.appState.statistics.graphJson ? JSON.parse(window.appState.statistics.graphJson) : [],
      options: {
        maintainAspectRatio: false,
        responsive: true,
        // layout: {
        //     padding: 20
        // },
        tooltips: {
          enabled: false
        },
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            ticks: {
              fontColor: '#666666',
              precision: 0,
              min: 0
            },
            display: false
          }],
          xAxes: [
            {
              ticks: {
                fontColor: '#666666'
              },
              gridLines: {
                display: false
              }
            }
          ]
        }
      }
    }
  },
  computed: {
    datacollection() {
      return {
        labels: this.graphJson.map(a => a.mesec),
        datasets: [
          {
            backgroundColor: '#64c400',
            data: this.graphJson.map(a => a.velPrenesenihDat),
            fill: false,
            lineTension: 0,
            borderColor: '#64c400',
            borderWidth: 5,
            pointRadius: 0
          }
        ]
      }
    }
  },
  methods: {
    redirectToAuthenticated(l) {
      window.location.href = window.appState.base_auth_url + l;
    }
  }
}
</script>

<style lang="scss">
.l-home {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__button {
    width: 109px;
    height: 39px;
    margin: 0px auto;
    color: #FFF;
    font-weight: 700;
    font-size: 18px;
    background-color: #64c400;
    border-radius: 3px;
    cursor: pointer;
    border: none;

    &:hover {
      background-color: #5BB000;
    }
  }

  &__statistics-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__chart-container {
    background-image: url("../assets/img/cloudWhite.png");
    background-repeat: no-repeat;
    background-position: center 45px;

    canvas {
      height: 219px;
      width: 580px;
    }
  }

  &__months-text {
    padding: 10px;
    color: #5BB000;
    font-weight: 600;
    font-size: 14px;
  }

  &__files-text {
    padding-bottom: 10px;
    font-weight: 600;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue